import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-packing-list',
  templateUrl: './packing-list.component.html',
  styleUrls: ['./packing-list.component.scss']
})
export class PackingListComponent implements OnInit {
  PackListForm: FormGroup;
  filteredDataList: any;
  DataList: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  listdesc: any;
  clgname: any;
  SessionNo: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.PackListForm = this.fb.group({
      PcklistNo: new FormControl(),
      PcklistNo2: new FormControl(),
      PcklistNo3: new FormControl('New'),
      PckValid: new FormControl(),
      PckChng: new FormControl(),
      PckSub: new FormControl(),
      PckHead: new FormControl(),
      PckMed: new FormControl(),
      PckBran: new FormControl(),
      EcId: new FormControl(),
     } );

  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  getExmFrmList(id){
    const payload = {};
    payload['InCode'] = id;
    payload['SnNo'] = this.SessionNo;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
      } else {
      }
    });
  }

  edit(k,id){
    if (k === 'true') {
      this.prepopulation(id);
    }
  }

  prepopulation(data){
    // // /this.PackListForm.controls['PcklistNo'].setValue(this.listdesc);
    // this.PackListForm = this.fb.group({
    //   PcklistNo: new FormControl(this.listdesc),
    //   PcklistNo2: new FormControl(''),
    //   PcklistNo3: new FormControl(''),
    //   PckValid: new FormControl(data.PckValid),
    //   PckChng: new FormControl(data.PckChng),
    //   PckSub: new FormControl(data.PckSub),
    //   PckMed: new FormControl(data.PckMed),
    //   PckBran: new FormControl(data.PckBran),
    //   EcId: new FormControl(data.EcId),
    //   PckHead: new FormControl(data.PckHead)
    //  } );
  }

  
  update(){
    if (this.PackListForm.invalid) {
      // this.PackListForm.get('EmCoCode').markAsTouched();
      // this.PackListForm.get('EmCode').markAsTouched();
      // this.PackListForm.get('EmName').markAsTouched();
      // this.PackListForm.get('EmShName').markAsTouched();
      // this.PackListForm.get('EmSubTot').markAsTouched();
      
      return;
    } else {
      this.updatePackList();
    }
  }
  updatePackList() {
    this.submitpayload = this.PackListForm.value;
    // this.umsService.updateCentAll(this.submitpayload).subscribe((res) => {
     
    //   if (res.status) {
    //     let data = {};
    //     data['message'] = res.message;
    //     data['title'] = 'Information';
    //     data['icon'] = 'fas fa-check';
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data);
    //   } else {
    //     let data = {};
    //     data['message'] = res.message;
    //     data['title'] = 'Information';
    //     data['icon'] = 'fas fa-check';
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data);
        
    //   }
    // },
    // (ERROR: HttpErrorResponse) => {
     
    //   let data = {};
    //   data['message'] = ERROR.error.message;
    //   data['title'] = 'Information';
    //   data['icon'] = 'fas fa-close';
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
    //     AlertBoxComponent,
    //     data
    //   );
    // });
  }


}


